import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import { Field as BaseField } from "rc-field-form";
import DateInput from "../../../../../../components/Inputs/DateInput";
import Field from "../../../../../../components/Field";
import { useCompanyDateFormat } from "../../../../../../utils/hooks/company";
import { dateTimeFormat } from "../../../../../../utils/helpers/date";
import { useTimeOffPlanVersions } from "../../Versions/useTimeOffPlanVersions";

// The day the changed settings take effect from: saving creates a new plan version starting then.
// A future date only schedules the change: the plan keeps its settings until that day.
// A plan has at most one scheduled (pending) version: a new save replaces it. Its versions (and
// Discard) are in the row action "Versions", not in the edit form.
// `editingScheduled`: the form holds that scheduled change, so no scheduled note here
// (the form's hint says which change is being edited).
function EffectiveDate({ planId, disabled, editingScheduled }) {
    const { t } = useTranslation();
    const dateFormat = useCompanyDateFormat();
    const { versions } = useTimeOffPlanVersions(planId);

    const scheduled = versions.find((version) => version.status === "pending") || null;

    return (
        <div className="rounded p-4 mb-4" style={{ background: "#f8f9f9" }}>
            {scheduled && !editingScheduled && (
                <small className="text-warning d-block mb-2">
                    {t("time-off-plan-scheduled-change", {
                        date: dateTimeFormat(scheduled.startEffectiveDate, dateFormat),
                    })}
                </small>
            )}

            <Field
                label={t("effective-date")}
                name="effectiveDate"
                rules={[
                    {
                        required: true,
                        message: t("required-date"),
                    },
                ]}
            >
                <DateInput
                    placeholderText={dateFormat || t("effective-date")}
                    disabled={disabled}
                />
            </Field>

            <BaseField shouldUpdate>
                {(_, __, { getFieldValue }) => {
                    const value = getFieldValue("effectiveDate");
                    if (!value) {
                        return null;
                    }
                    if (moment(value).isBefore(moment(), "day")) {
                        return (
                            <small className="text-info d-block">
                                {t("time-off-plan-backdated-locked-periods-note")}
                            </small>
                        );
                    }
                    if (moment(value).isAfter(moment(), "day")) {
                        return (
                            <small className="text-info d-block">
                                {t("time-off-plan-scheduled-note")}
                            </small>
                        );
                    }
                    return null;
                }}
            </BaseField>
        </div>
    );
}

export default EffectiveDate;
